import type { Lang } from '../../lib/i18n';
import { matchupStrings } from '../../lib/tools';
import { EmbedLayout } from '../../components/tools/ToolParts';
import { MATCHUP_SLUG, Matchup } from '../../components/tools/Matchup';

export default function MatchupEmbed({ lang = 'en' as Lang }: { lang?: Lang }) {
  const t = matchupStrings(lang);
  return (
    <EmbedLayout lang={lang} slug={MATCHUP_SLUG} title={t.embed.frameTitle} credit={t.embed.credit}>
      <Matchup lang={lang} embed />
    </EmbedLayout>
  );
}
